import { env } from '@/config/env'
import { DEV_AUTH_SENTINEL } from '@/lib/devAuth'
import { resolveOwnerSpaceId } from '@/lib/currentOrg'
import { useAuthStore } from '@/store/useAuthStore'
import { useUserStore } from '@/store/useUserStore'
import { TOKEN_KEY, storage } from '@/utils/storage'

function readSessionJwt(): string | null {
  const fromStore = useAuthStore.getState().token
  const raw = (fromStore || storage.get(TOKEN_KEY) || '').trim()
  if (!raw || raw === DEV_AUTH_SENTINEL) return null
  return raw.startsWith('Bearer ') ? raw : `Bearer ${raw}`
}

/**
 * 这次请求实际会带上的空间 id。
 * 显式 orgId → 当前空间（顶栏切换后的 space_id）→ mock 才落到 `VITE_DEV_ORG_ID`。
 */
export function resolveRequestOrgId(orgId?: string | null): string {
  return (
    orgId?.trim() ||
    resolveOwnerSpaceId(useUserStore.getState().space_id) ||
    env.devOrgId?.trim() ||
    ''
  )
}

/**
 * Authorization：正式 JWT 优先，否则回落 `VITE_DEV_AUTHORIZATION`。
 * x-org-id 与 resolveRequestOrgId 一致。
 */
export function applyAuthHeaders(headers: Headers, orgId?: string | null) {
  if (!headers.has('Authorization')) {
    const jwt = readSessionJwt()
    if (jwt) headers.set('Authorization', jwt)
    else if (env.devAuthorization?.trim()) {
      headers.set('Authorization', env.devAuthorization.trim())
    }
  }

  if (!headers.has('x-org-id')) {
    const id = resolveRequestOrgId(orgId)
    if (id) headers.set('x-org-id', id)
  }
}
